exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.pix-signalr-manager-status_online[data-v-f40b5c60] {\r\n  width: 16px;\r\n  height: 16px;\r\n  border-radius: 50%;\r\n  background-color: green;\n}\n.pix-signalr-manager-status_offline[data-v-f40b5c60] {\r\nwidth: 16px;\r\n  height: 16px;\r\n  border-radius: 50%;\r\n  background-color: red;\n}\r\n\r\n", ""]);

// exports
